module.exports = __webpack_public_path__ + "img/Plantillas.2b4be846.svg";